<div class="container" [formGroup]="inputForm">
  <div class="row">
    <div class="col col-12">
      <mat-radio-group class="radio-buttons" formControlName="enableEmails">
        <mat-radio-button class="me-2" value="EmailsEnabled"
          >Enable emails</mat-radio-button
        >
        <mat-radio-button class="me-2" value="CampaignsSuspended"
          >Suspend campaigns</mat-radio-button
        >
        <mat-radio-button class="me-2" value="EmailsSuspended"
          >Suspend emails</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
</div>
